module.exports = __webpack_public_path__ + "static/media/18ECA33.ca33f91f.jpg";